export default function modal(state = {}, action) {
	switch (action.type) {
		case 'SET_ACTIVE_MODAL':
			return { modalComponent: action.component, modalProps: action.props };
		case 'CLOSE_ACTIVE_MODAL':
			return {};
	}
	return state;
}
